import { useQuery } from '@tanstack/react-query';

import { paymentTypeTypes } from '../types';

import { axios } from '@/libraries/axios';
import { ExtractFnReturnType, QueryConfig } from '@/libraries/react-query';

export const getPaymentTypes: paymentTypeTypes.GetPaymentTypes = () => {
  return axios.get(`/payment-types`);
};

type QueryFnType = typeof getPaymentTypes;

type UseGetPaymentTypesOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetPaymentTypes = ({ config = {} }: UseGetPaymentTypesOptions = {}) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['payment-types'],
    queryFn: () => getPaymentTypes(),
  });
};
